<template>
    <section class="page-section" v-loading="pageLoading">
        <el-form size="small" label-width="0px" class="content-form">
            <template v-for="(record, recordIndex) in listData">
                <div class="level-item" :key="recordIndex">
                    <el-form-item label="" required :show-message="false">
                        <div class="content">
                            <div class="item">
                                <div class="label">服务代理等级</div>
                                <div class="cont">
                                    <el-input v-model="record.name" class="w120"></el-input>
                                </div>
                            </div>
                            <div class="item" style="width: 300px;">
                                <div class="label">服务订单销售额</div>
                                <div class="cont">
                                    <el-input v-model="record.start" class="w120"></el-input>
                                    <template v-if="record.level == 1 || record.level == 2 || record.level == 3">
                                        <span class="sep">元&nbsp;&nbsp;-&nbsp;&nbsp;</span>
                                        <el-input v-model="record.end" class="w120"></el-input>
                                        <span class="sep">元</span>
                                    </template>
                                    <template v-if="record.level == 4">
                                        <span class="sep">元以上</span>
                                    </template>
                                </div>
                            </div>
                            <div class="item">
                                <div class="label">一级代理服务分佣</div>
                                <div class="cont">
                                    <el-input v-model="record.servicePercentage" class="w120">
                                        <template slot="append">%</template>
                                    </el-input>
                                </div>
                            </div>
                        </div>
                    </el-form-item>
                </div>
            </template>
            <div class="btn-wrap">
                <el-button type="primary" size="small" :loading="submitLoading" @click="handleSave">保存</el-button>
                <el-button size="small" type="default" plain @click="handleback">取消</el-button>
            </div>
        </el-form>
    </section>
</template>

<script>
    import { COMMON, agentServiceLevelList, agentServiceLevelSave } from '@/common/api'

    export default {
        name: 'serviceLevel',
        props: {
            type: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                COMMON,
                pageLoading: true,

                listData: [],
                submitLoading: false,

                requestNum: 0
            }
        },
        mounted() {
            this.getList();
        },
        methods: {
            /**
             * [getList description] 获取列表
             * @return {[type]} [description]
             */
            getList: function() {
                this.pageLoading = true;

                let params = {
                    type: this.type
                }

                agentServiceLevelList(params).then(res => {
                    let { code, data, msg } = res;

                    if(code == 0) {
                        this.pageLoading = false;
                        
                        this.listData = data || []
                    } else {
                        this.$message.error(msg);
                    }
                }).catch(error => {
                    console.log(error)
                    this.$message.error('服务器异常');
                });
            },
            /**
             * [handleSave description] 保存数据
             * @return {[type]} [description]
             */
            handleSave: function(formName) {
                let listData = JSON.parse(JSON.stringify(this.listData))
                for(let i = 0; i < listData.length; i++) {
                    let row = listData[i]
                    if(!row.name) {
                        this.$message.error('请输入服务代理等级名称');
                        this.$forceUpdate()
                        return false;
                    }
                    if(row.start === '') {
                        row.start = ''
                        this.$message.error('请输入服务订单销售额起始值');
                        this.$forceUpdate()
                        return false;
                    }
                    if(row.end === '') {
                        row.end = ''
                        this.$message.error('请输入服务订单销售额的结束值');
                        this.$forceUpdate()
                        return false;
                    }
                    if(row.servicePercentage === '') {
                        row.servicePercentage = ''
                        this.$message.error('请输入服务订单分佣比例');
                        this.$forceUpdate()
                        return false;
                    }
                }

                this.submitLoading = true;

                for(let i = 0; i < listData.length; i++) {
                    this.doRequest(listData[i])
                }
            },
            doRequest(row) {
                let params = row

                agentServiceLevelSave(params).then(res =>{
                    let { code, data, msg } = res;

                    if(code == 0) {
                        this.requestNum += 1;
                        if(this.requestNum == this.listData.length) {
                            this.submitLoading = false;
                            this.requestNum = 0
                            this.$message({ message: '保存成功', type: 'success' });
                        }
                    } else {
                        this.$message.error(msg);
                    }
                }).catch(error => {
                    this.submitLoading = false;
                    this.$message.error('服务器异常');
                });
            },
            /**
             * [handleback description] 取消-返回列表
             * @return {[type]}          [description]
             */
            handleback: function() {
                if(this.type == 1) {
                    this.$router.push('/agent/person/list');
                } else {
                    this.$router.push('/agent/company/list');
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../common/styles/base/mixin-font";
    @import "../../../common/styles/base/mixin-common";

    .level-item{
        margin: 0 10px;
        border-bottom: 1px solid rgba(#000, .15);

        & + .level-item{
            margin-top: 10px;
        }

        .title{
            font-size: 14px;
            color: #222222;
            letter-spacing: 0;
            font-weight: 500;
        }

        .content{
            display: flex;
            flex-direction: row;
            align-items: center;

            .item{
                
                & + .item{
                    margin-left: 20px;
                }

                .cont{
                    .sep{
                        margin: 0 4px;
                    }
                }
            }
        }
    }
    
    .btn-wrap{
        margin: 20px 10px;
    }
</style>
